import * as React from "react";
import { size, lineHeight, fontFamily } from "@clockwise/web-commons/src/styles/type.styles";
import { headerColor } from "@clockwise/web-commons/src/styles/color.styles";
import { CWIDProps } from "@clockwise/web-commons/src/util/cw-id.util";

const baseStyles: React.CSSProperties = {
  fontFamily,
  fontSize: size.std,
  fontWeight: "bold",
  lineHeight: lineHeight.std,
  marginBottom: ".5rem",
  color: headerColor,
};

export function H2(
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & CWIDProps,
) {
  const styles = Object.assign({}, baseStyles, props.style);
  const mergedProps = Object.assign({}, props, { style: styles });
  return (
    <div {...mergedProps} cw-id={props["cw-id"]}>
      {props.children}
    </div>
  );
}
